module.exports = __webpack_public_path__ + "static/img/safe.b0dc85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/safe.png
// module id = wvO7
// module chunks = 6